import React from 'react';
import { useT } from '@repo/common';
import AccountChangeBanner from './AccountChangeBanner';

const actionClass = 'shrink-0 pl-2 typo-b14 text-text-primary underline underline-offset-2 hover:text-green-deep03 focus-visible:outline-green-deep03';

function AccountRow({ title, description, children }) {
  return (
    <div className='flex items-center w-full'>
      <div className='flex min-w-0 flex-1 flex-col gap-0.5 pr-2'>
        <p className='typo-b14Strong text-text-primary'>{title}</p>
        <p className='typo-b12 text-text-placeholder'>{description}</p>
      </div>
      {children}
    </div>
  );
}

export default function AccountConversionRows({ isBusiness, isCreator, onConvert, notices = [], onDismiss }) {
  const t = useT();
  return (
    <>
      <div className='flex w-full flex-col gap-3'>
      <AccountRow
        title={isBusiness ? t('Change to personal account', '개인 계정으로 변경') : t('Change to business account', '비즈니스 계정으로 변경')}
        description={isBusiness
          ? t('To change your account type, contact us.', '계정 유형을 변경하려면 문의해 주세요.')
          : t('Use Koready as an employer. To change back, contact us.', '고용주로 Koready를 이용하세요. 개인 계정으로 돌아가려면 문의해 주세요.')}
      >
        {isBusiness ? (
          <a className={actionClass} href='mailto:hello@ko-ready.com'>{t('Contact us', '문의하기')}</a>
        ) : (
          <button type='button' className={actionClass} onClick={() => onConvert('business')}>{t('Change', '변경')}</button>
        )}
      </AccountRow>
      {!isBusiness && <AccountChangeBanner notice={notices.find((notice) => notice.kind === 'BUSINESS_REMOVED')} onDismiss={onDismiss} />}
      </div>
      <div className='flex w-full flex-col gap-3'>
      <AccountRow
        title={isCreator ? t('Creator Studio', '크리에이터 스튜디오') : t('Become an Creator', '크리에이터 시작하기')}
        description={isCreator
          ? t("You're an Creator. Create and manage your courses.", '크리에이터 계정입니다. 강의를 만들고 관리하세요.')
          : t('Create and sell your own courses. Your account stays the same.', '나만의 강의를 만들고 판매하세요. 기존 계정은 그대로 유지됩니다.')}
      >
        {isCreator ? (
          <a className={actionClass} href='https://skills.ko-ready.com/creatorStudio'>{t('Open', '열기')}</a>
        ) : (
          <button type='button' className={actionClass} onClick={() => onConvert('creator')}>{t('Start', '시작')}</button>
        )}
      </AccountRow>
      {!isCreator && <AccountChangeBanner notice={notices.find((notice) => notice.kind === 'CREATOR_REMOVED')} onDismiss={onDismiss} />}
      </div>
    </>
  );
}
